export const menuItems = [
  {
    id: 1,
    label: "common.library",
    isTitle: true,
  },

  {
    id: 2,
    label: "common.library",
    icon: "mdi mdi-database",
    subItems: [
      {
        id: "policy-parent",
        label: "policy.text",
        subItems: [
          {
            id: "policy",
            label: "policy.text",
            link: "/management/policy",
          },
          {
            id: "policy-category",
            label: "policy-category.text",
            link: "/management/policy-category",
          },
        ],
      },

      {
        id: "question-set",
        label: "question-set.plural",
        subItems: [
          {
            id: "question-set",
            label: "question-set.plural",
            link: "/management/question-set",
          },
          {
            id: "question",
            label: "question.text",
            link: "/management/question",
          },
        ],
      },
      {
        id: "report-template",
        label: "report-template.text",
        subItems: [
          {
            id: "report-template",
            label: "report-template.text",
            link: "/management/report-template",
          },
        ],
      },
    ],
  },

  {
    id: 6,
    isLayout: true,
  },
  {
    id: 7,
    label: "account.text",
    isTitle: true,
  },

  {
    id: "app-panel",
    label: "common.panel",
    icon: "bx-user",
    link: "/management/account-workspace-organization",
  },

  {
    id: "role-management",
    label: "role.plural",
    icon: "bx-shield-quarter",
    link: "/management/role",
  },

  {
    id: "role-access-management",
    label: "role.access.text",
    icon: "bx-shield-quarter",
    link: "/management/role-access",
  },
  {
    id: 105,
    label: "common.system",
    isTitle: true,
  },
  {
    id: "log",
    label: "log.text",
    icon: "bx-code",
    link: "/management/log",
  },
  {
    id: "mail-log",
    label: "log.mail.text",
    icon: "mdi mdi-email-check-outline",
    link: "/management/mail-log",
  },

  // {
  //   id: "announcement",
  //   label: "announcement.plural",
  //   icon: "bx bxs-megaphone",
  //   link: "/management/announcement",
  // },
  {
    id: "config",
    label: "config.text",
    icon: "bx bx-cog",
    link: "/management/config",
  },
];
